<template>
    <div>
        <el-dialog title="查看" :visible.sync="dialogVisble" :before-close="hideDialog" width="1000px" top="5vh"
            :close-on-click-modal="false">
            <el-form>
                <el-form-item style="background-color:#ebeef5;" label-width="0px">
                    <span>商品信息</span>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="商品名称 :" style="width:30%; display: inline-block">
                        <input type="text" readonly :value="formData.commodityname" />
                    </el-form-item>
                    <el-form-item label="序列号:" style="width:30%;display: inline-block;margin-left:0px;">
                        <input type="text" readonly :value="formData.commoditynum" />
                    </el-form-item>
                    <el-form-item label="商品分类:" style="width:30%;display: inline-block;margin-left:0px;">
                        <input :value="formData.classifytitle" type="text" readonly />
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="应用场景:" style="width:30%;display: inline-block">
                        <input :value="formData.Sencename" type="text" readonly />
                    </el-form-item>
                    <el-form-item label="产品编码:" style="width:30%;display: inline-block;margin-left:0px;">
                        <input :value="formData.commoditysort" readonly type="text" />
                    </el-form-item>
                    <el-form-item label="添加时间:" style="width:30%;display: inline-block">
                        <input :value="formData.commoditytime| formatDateStr('yyyy-MM-dd hh:mm:ss')" readonly
                            type="text" />
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="缩略图:">
                        <span v-if="formData.commodityurl != null">
                            <el-popover placement="right" trigger="hover" style="margin-right:5px;">
                                <img :src="formData.commodityurl" style="width:400px;border-radius:3px;" />
                                <img slot="reference" :src="formData.commodityurl"
                                    style="height: 150px;width: 150px;border-radius:5px;" />
                            </el-popover>
                        </span>
                        <span v-else>
                            暂无图片
                        </span>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="轮播图:">
                        <span v-if="formData.comCarousels != null &&formData.comCarousels.length >0">
                            <el-popover placement="right" trigger="hover" v-for="(item, index) in formData.comCarousels"
                                :key="index" style="margin-right:5px;">
                                <img :src="item.carouselurl" style="width:400px;border-radius:3px;" />
                                <img slot="reference" :src="item.carouselurl"
                                    style="height: 150px;width: 150px;border-radius:5px;" />
                            </el-popover>
                        </span>
                        <span v-else>
                            暂无图片
                        </span>
                    </el-form-item>
                </el-form-item>
                <br />
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="材质规格:">
                        <br />
                        <span v-for="(item, index) in formData.comSpecs" style="display: block;margin-left: 20px;"
                            :key="index">
                            材质规格：{{ item.specstand }}&nbsp;&nbsp;&nbsp;&nbsp;
                            价格：{{item.specprice}}&nbsp;&nbsp;&nbsp;&nbsp;
                            起订量：{{item.specnum}}&nbsp;&nbsp;&nbsp;&nbsp;
                            重量：{{item.speclweight}}&nbsp;&nbsp;&nbsp;&nbsp;
                            口径：{{item.specidcaliber}}&nbsp;&nbsp;&nbsp;&nbsp;
                            外形尺寸：{{item.specsize}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span v-if="item.specdefault == 1">默认</span>
                        </span>
                    </el-form-item>
                </el-form-item>
                <br />
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="价格比率:">
                        <br />
                        <div class="list">
                            <div class="list-item2">
                                <span>1级：</span>
                                <span>{{formData.vip1}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>2级：</span>
                                <span>{{formData.vip2}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>3级：</span>
                                <span>{{formData.vip3}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>4级：</span>
                                <span>{{formData.vip4}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>5级：</span>
                                <span>{{formData.vip5}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>6级：</span>
                                <span>{{formData.vip6}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>7级：</span>
                                <span>{{formData.vip7}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>8级：</span>
                                <span>{{formData.vip8}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>9级：</span>
                                <span>{{formData.vip9}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>10级：</span>
                                <span>{{formData.vip10}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>11级：</span>
                                <span>{{formData.vip11}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>12级：</span>
                                <span>{{formData.vip12}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>13级：</span>
                                <span>{{formData.vip13}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>14级：</span>
                                <span>{{formData.vip14}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>15级：</span>
                                <span>{{formData.vip15}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>16级：</span>
                                <span>{{formData.vip16}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>17级：</span>
                                <span>{{formData.vip17}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>18级：</span>
                                <span>{{formData.vip18}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>19级：</span>
                                <span>{{formData.vip19}}%</span>
                            </div>
                            <div class="list-item2">
                                <span>20级：</span>
                                <span>{{formData.vip20}}%</span>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                  <el-form-item label="国家配置:">
                      <br />
                      <div class="list">
                          <div class="list-item3" v-for="(item,index) in formData.mbCountryList"
                          :key="index">
                              <span>{{item.name}}</span>
                          </div>
                      </div>
                  </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="规格数据:">
                        <br />
                        <div class="list" v-if="formData.commoditySearchitemList">
                            <div class="list-item" v-for="(item,index) in formData.commoditySearchitemList"
                                :key="index">
                                <span>{{item.hfSerchitem.name}}：</span>
                                <span>{{item.typeVal}}</span>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="场景数据规格:">
                        <br />
                        <div class="list" v-if="formData.commoditySearchitemListSence">
                            <div class="list-item" v-for="(item,index) in formData.commoditySearchitemListSence"
                                 :key="index">
                                <span>{{item.hfSerchitem.name}}：</span>
                                <span>{{item.typeVal}}</span>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>


                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="商品详情:">
                        <br />
                        <span class="detailbox" v-html="formData.commoditydetail">
                        </span>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="相关文档:">
                        <br>
                        <div style="margin-left:20px" v-for="(item,index) in formData.hfCommodityAccessories"
                            :key="index">
                            <i class="el-icon-document"></i>
                            <span class="textBox"><a :href='item.url'>{{item.name}}</a></span>
                        </div>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="置换数据:">
                        <br>
                        <div class="pl" v-for="(item, index) in hfUnitReplacementList" :key="index">
                            <label>{{item.cn}}：</label>
                            <div class="mt">
                                <el-tag class="tagStyle" v-for="(itm, idx) in item.name" :key="idx">
                                    {{itm}}
                                </el-tag>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="hideDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getCommodityInfo
    } from "../../api/product/product";
    export default {
        data() {
            return {
                dialogVisble: false, //弹框开关
                formData: "",
                hfUnitReplacementList: [{
                    cn: "制造商",
                    en: "",
                    type: 1,
                    name: []
                }, {
                    cn: "型号",
                    en: "",
                    type: 2,
                    name: []
                }, {
                    cn: "板数",
                    en: "",
                    type: 3,
                    name: []
                }, {
                    cn: "应用",
                    en: "",
                    type: 4,
                    name: []
                }], //置换数据
            };
        },

        methods: {
            openDialog(id) {
                this.dialogVisble = true;
                getCommodityInfo({
                        commodityid: id
                    })
                    .then((res) => {
                        this.formData = res.data;
                        this.formData.Sencename = res.data.hfSence.name
                        //置换数据
                        if (res.data.hfUnitReplacementList.length > 0) {
                            this.hfUnitReplacementList.forEach(item => {
                                res.data.hfUnitReplacementList.forEach(itm => {
                                    if (item.type == itm.type) {
                                        item.name.push(itm.name)
                                    }
                                })
                            })
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            },
            /*隐藏查看弹框*/
            hideDialog() {
                this.dialogVisble = false;
                Object.assign(this.formData, this.$options.data().formData);
                this.hfUnitReplacementList=this.$options.data().hfUnitReplacementList
            },
        },

        filters: {
            price: function (myInput) {
                var val = parseInt(myInput);
                if (typeof val === "number") {
                    return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                }
            },
        },

        created() {
            // this.getClassify(); //查询分类
            // this.getSence(); //查询一级场景
        },
    };

</script>

<style lang="scss" scoped>
    .list {
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;

        .list-item {
            width: 25%;
        }

        .list-item2 {
            width: 20%;
        }
        .list-item3{
          width: 10%;
        }
    }

    .labelClass {
        display: inline-block;
        width: 90px;
        text-align: right;
    }

    .textBox {
        max-width: 100%;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        a {
            color: #333;
        }
    }

    .el-dialog>.el-dialog__footer>.dialog-footer>.pagination-container {
        margin: 10px;
        float: none;
    }

    .detailbox {
        width: 100%;
        margin-left: 20px;
        display: block;

        img {
            display: block;
            max-width: 100%;
            height: auto !important;
            margin-bottom: 10px;
        }
    }

    .mt {
        margin-bottom: 10px;
    }

    .tagStyle {
        margin-right: 10px;
        height: 32px;
        padding: 0 10px;
        line-height: 30px;
        margin-bottom: 5px;
    }

    .pl {
        padding-left: 20px;
    }

</style>
